const defaultState = []

export default (state = defaultState, action) => {

    switch (action.type) {

        case 'CLEAR_ALL_ALERTS':
            return [];

        case 'CLEAR_ALL_NOT_STICKY_ALERTS':
            return [...state.filter(d => d.sticky)]

        case 'REMOVE_ALERT':
            return [...state.filter(d => d.id !== action.id)];

        case 'ADD_ALERT':
            if (!state.map(d => d.id).includes(action.id)) {
                return [action.data, ...state];
            } 
                return state;
            

        default:
            return state
    }
}
